/* eslint-disable @typescript-eslint/naming-convention */
// import history from './History'; // Removed in v6

const ga = (window as any).ga;

export const trackError = (e) => {
  ga('send', 'event', 'errors', e);
  ga('send', 'exception', {
    exDescription: e,
    exFatal: false,
  });
};

export default function () {
  // Note: In React Router v6, we'll handle pageview tracking differently
  // This will be moved to a React component that uses useLocation hook
  // For now, just set up error tracking

  window.addEventListener('error', function ({ error: e }) {
    if (e) {
      trackError(e.message + 'from' + e.stack);
    }
  });
}
